<template>
	<div>
		<h3 v-if="title" class="mb-2">{{title}}</h3>
		<display-text-component label="Imię" :value="name" :flex="'full-width'"/>
		<display-text-component label="Nazwisko" :value="surname" :flex="'full-width'"/>
		<display-text-component label="Funkcja" :value="bidderRole" :flex="'full-width'"/>
	</div>
</template>

<script>
	import displayTextComponent from "./DisplayTextComponent";

	export default {
		name: "BidderSummaryData",
		components: {
			displayTextComponent
		},
		props: {
			title: String,
			name: String,
			surname: String,
			bidderRole: String
		}
	};
</script>

<style scoped>

</style>
